module.exports = __webpack_public_path__ + "img/2.549f60eb.png";